import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";
import {THEME} from "../../../../app/consts";

export class ScoresEmptyStateLiveRequestParams extends AssetsRequestParams {

  constructor(width: Number,height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/EmptyState/empty_state_live`
  }

  get pathPostfix(): String {
    return super.pathPostfix + (this.theme === THEME.DARK ? `_dark` : '');
  }
}
